import {
  createAction,
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { ICreateLotModalState } from './interfaces';
import { postRequest } from 'api/requests';
import { ILot } from 'interfaces/main';
import { defaultLot } from 'consts/default';

// Открытие окна с новым лотом
export const openCreateLotModal = createAction(
  'createLotModal/openCreateLotModal',
  ({ complexId }: { complexId: number }) => ({
    payload: { complexId },
  }),
);

// Закрытие окна с новой организацией
export const closeModal = createAction('createLotModal/closeModal');

// Добавление новой группы
export const createLot = createAsyncThunk(
  'createLotModal/createLot',
  async (newLot: ILot, { rejectWithValue }) => {
    try {
      const response = await postRequest('lot', newLot, true);

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const initialState: ICreateLotModalState = {
  data: defaultLot,
  isLoading: false,
  isVisible: false,
};

const createLotModalSlice = createSlice({
  name: 'createLotModal',
  initialState,
  reducers: {
    openCreateLotModal: (_, { payload }) => ({
      ...initialState,
      isVisible: true,
      data: {
        ...defaultLot,
        ...payload,
      },
    }),
    closeModal: () => initialState,
    changeField: (state, { payload }) => ({
      ...state,
      data: {
        ...state.data,
        [payload.field]: payload.value,
      },
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLot.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(createLot.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(createLot.fulfilled, () => initialState);
  },
});

// Селекторы
export const CreateLotModalSelector = (
  state: RootState,
): ICreateLotModalState => state.createLotModal;

export const CreateLotModalLoadingSelector = createSelector(
  CreateLotModalSelector,
  ({ isLoading }) => isLoading,
);

export const CreateLotModalVisibleSelector = createSelector(
  CreateLotModalSelector,
  ({ isVisible }) => isVisible,
);

export const CreateLotModalDataSelector = createSelector(
  CreateLotModalSelector,
  ({ data }) => data,
);

export default createLotModalSlice.reducer;
